import { Component } from '@angular/core';
import { IosDialogService, LicensesService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmDialogComponent } from '../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-activate-license-dialog',
  templateUrl: './activate-license-dialog.component.html',
  styleUrls: ['./activate-license-dialog.component.scss'],
})
export class ActivateLicenseDialogComponent {
  serialNumber: string = '';

  // renew license
  licenseToBeRenewedId: string | null = null;
  expirationTime: Date | null = null;
  selectedFile: File | null = null;

  constructor(
    private licensesService: LicensesService,
    private translate: TranslateService,
    private ref: DynamicDialogRef,
    private dialog: IosDialogService,
    public dialogData: DynamicDialogConfig,
  ) {
    this.licenseToBeRenewedId = this.dialogData.data?.licenseToBeRenewedId;
    this.expirationTime = this.dialogData.data?.expirationTime;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  offlineActivation() {
    console.log('Inizio attivazione licenza offline');
    const serialNumber = this.serialNumber.toUpperCase().trim();
    if (!serialNumber) return;

    if (!this.selectedFile) {
      return;
    }

    this.licensesService
      .offlineActivation(serialNumber, this.selectedFile)
      .then(({ licenseData: { licenses, licenseBundle } }) => {
        this.ref.close({ licenses, licenseBundle });
      })
      .catch((err) => {
        const statusCode = err.error.statusCode;
        const [param] = err.error.params ?? [];
        const message = (() => {
          if (statusCode === 500) return this.translate.instant('TOAST.GENERAL_ERROR');
          if (!param) return this.translate.instant(`OFFLINE_ACTIVATION_ERR.${statusCode}`);
          if (param) {
            return this.translate.instant(`OFFLINE_ACTIVATION_ERR.${statusCode}.${param.toUpperCase()}`);
          }
        })();
        return this.dialog.openAndWaitResponse(ConfirmDialogComponent, {
          showHeader: false,
          width: 'min(450px, 90vw)',
          data: {
            title: message,
            primaryButtonText: 'Ok',
            showCloseButton: false,
            showCancelButton: false,
          },
        });
      });
  }
}
